export default __webpack_public_path__ + "static/media/background-redeem.cce139e5.png";